import { Component, ViewEncapsulation } from '@angular/core';
@Component({
    selector: 'kh-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.less'],
    standalone: false
})
export class KhTableComponent {}
